/**
 * Pagebuilder -> Sections -> Default
 */

import React from 'react';

const Default = () => <section className="section">No section found</section>;

export default Default;
